import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomFilledButton from "../../components/CustomFilledButton";
import CustomOutlinedButton from "../../components/CustomOutlined";
import {
  REACT_EMPLOYEE_LOGIN_SCREEN,
  REACT_FEEDBACK_SCREEN,
  REACT_FUNCTION_KEY_SCREEN,
} from "../../constants/ReactEndPoints";
import { uploadAttRecords } from "../../services/FunctionKeysService";
import CommonUtil from "../../util/CommonUtils";
import { useSelector } from "react-redux";
import {
  selectCurrentFunctionKey,
  selectShiftId,
} from "../../feature/Dashboard/dashboardSelectors";
import { showMessage, updateObjectInArray } from "../../util/helperFunction";
import { useTranslation } from "react-i18next";

const GeneralQuestion = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [payload, setPayload] = useState({ data: [] });
  const selectedFunctionKeyObj = useSelector(selectCurrentFunctionKey);
  const { punchPayload, customMappingObj = {} } = location?.state || {};
  const shiftId = useSelector(selectShiftId);

  useEffect(() => {
    if (!CommonUtil.isTruthyValue(localStorage.getItem("isLoggedIn"))) {
      navigate(REACT_EMPLOYEE_LOGIN_SCREEN, { replace: true });
    }
  }, []);

  useEffect(() => {
    if (punchPayload && selectedFunctionKeyObj) {
      const {
        splitPunchCondition,
        splitPunchTimeDuration,
        addClosePunch,
        closePunchEventCode,
      } = selectedFunctionKeyObj;

      const splitCondition = CommonUtil.parseIntoNumeric(splitPunchCondition);
      const splitDuration = CommonUtil.parseIntoNumeric(splitPunchTimeDuration);

      const isSplitPunchEnable =
        addClosePunch && !CommonUtil.isEmptyString(closePunchEventCode);

      const updatedPunchData = updateObjectInArray(
        punchPayload,
        {
          ...customMappingObj,
          shiftId: shiftId,
        },
        0
      );

      let updatedPayload = [...updatedPunchData];

      if (!isSplitPunchEnable && punchPayload?.length > 1) {
        updatedPayload = updatedPayload?.splice(0, 1);
      }

      if (
        isSplitPunchEnable &&
        !CommonUtil.isEmpty(splitCondition) &&
        splitCondition === "1" &&
        (CommonUtil.isEmpty(splitDuration) || splitDuration === "0")
      ) {
        if (punchPayload?.length > 1) {
          updatedPayload = updatedPayload?.splice(0, 1);
        }
      }

      if (
        isSplitPunchEnable &&
        CommonUtil.isEmpty(splitCondition) &&
        CommonUtil.isEmpty(splitDuration)
      ) {
        updatedPayload = updatedPayload?.reverse();
      }

      if (
        isSplitPunchEnable &&
        !CommonUtil.isEmpty(splitCondition) &&
        splitCondition === "0" &&
        !CommonUtil.isEmpty(splitDuration)
      ) {
        updatedPayload = updatedPayload?.reverse();
      }

      if (
        isSplitPunchEnable &&
        !CommonUtil.isEmpty(splitCondition) &&
        splitCondition === "0" &&
        CommonUtil.isEmpty(splitDuration)
      ) {
        updatedPayload = updatedPayload?.reverse();
      }

      setPayload({ data: updatedPayload });
    }
  }, [punchPayload, customMappingObj, shiftId, selectedFunctionKeyObj]);

  const handleSubmit = async () => {
    try {
      const response = await uploadAttRecords(payload);

      if (response?.status === 201 && response?.data?.message === "Success") {
        navigate(REACT_FEEDBACK_SCREEN, { state: { punchPayload } });
      } else {
        showMessage("error", t("generalQuestion.errors.unexpectedResponse"));
        console.log("Unexpected response while submitting punch:", response);
      }
    } catch (error) {
      showMessage(
        "error",
        t("generalQuestion.errors.submitError", {
          error: error.message || error,
        })
      );
      console.error("Error while submitting the final punch:", error);
    }
  };

  const handleCancel = () => {
    navigate(REACT_FUNCTION_KEY_SCREEN);
  };

  return (
    <Grid container sx={{ padding: "30px 30px 0px 30px" }}>
      <Grid item xs={11}>
        <Box sx={{ paddingBottom: "30px" }}>
          <Typography sx={{ fontSize: "20px", fontWeight: 600, fontFamily: "inter" }}>
            {t("generalQuestion.confirmation.question", {
              action: (selectedFunctionKeyObj.label || "").toLowerCase(),
            })}
          </Typography>
        </Box>

        <Box>
          <Typography sx={{ fontSize: "20px", fontFamily: "inter" }}>
            {t("generalQuestion.confirmation.employeeId", {
              id: localStorage.getItem("employeeNumber"),
            })}
          </Typography>
        </Box>

        <Box
          sx={{
            position: "absolute",
            right: "15px",
            bottom: "20px",
            display: "flex",
          }}
        >
          <CustomOutlinedButton
            onBtnClick={handleCancel}
            title={t("generalQuestion.buttons.no")}
          />

          <Box sx={{ marginLeft: "20px" }}>
            <CustomFilledButton
              onBtnClick={handleSubmit}
              title={t("generalQuestion.buttons.yes")}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default GeneralQuestion;
